import axios from 'axios';
import { Dialog } from 'vant';
import { getItem, setItem } from '@/common/storage';
import {
  jumpToWechatAuth,
  isWechat,
  isLocalhost,
  getUrlParams,
  isWechatAuthRequired,
  markWechatOAuthDone,
} from '@/utils/wechatAuth';
import { shouldOAuthOnIndexAfterBind } from '@/utils/nameAuth';

axios.defaults.timeout = 3000000;

// 收到 show 401 后不再发请求，等授权回来再调，避免多次 401 重复跳转
let needWechatAuth = false;
let pending401JumpTimer = null;
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;

//返回其他状态吗
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500; // 默认的
};
//跨域请求，允许保存cookie
axios.defaults.withCredentials = true;

//HTTPrequest拦截
axios.interceptors.request.use(
  (config) => {
    const url = config.url || config.baseURL || '';
    const hasCode = !!getUrlParams().code;
    if (
      needWechatAuth &&
      isWechatAuthRequired() &&
      shouldOAuthOnIndexAfterBind(url) &&
      !hasCode &&
      isWechat() &&
      !isLocalhost()
    ) {
      jumpToWechatAuth();
      return Promise.reject(new Error('等待授权'));
    }
    if (hasCode) needWechatAuth = false;

    const header = {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    };
    if (['get', 'GET', 'delete', 'DELETE'].includes(config.method)) {
      header['Content-Type'] =
        'application/x-www-form-urlencoded; charset=UTF-8';
      config.params = config.data;
      delete config.data;
    }
    if (config.method === 'post' && config.headers['Content-Type']) {
      header['Content-Type'] = config.headers['Content-Type'];
    }
    let token = getItem('token');
    if (token) {
      header['token'] = token;
    }
    config.headers = {
      ...config.headers,
      ...header,
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//HTTPresponse拦截
axios.interceptors.response.use(
  async (res) => {
    const { status } = res;
    var data = res.data;
    
    // 200 成功时取消待跳转
    if (status === 200 || status === 204) {
      needWechatAuth = false;
      if (pending401JumpTimer) {
        clearTimeout(pending401JumpTimer);
        pending401JumpTimer = null;
      }
    }

    // 微信内：show 401 跳授权；绑定后进首页时 topics/item 401 也在首页授权一次
    const is401 = Number(status) === 401 || (data && String(data.status) === '401');
    const reqUrl = res.config?.url || '';
    const inWechat = isWechatAuthRequired() && isWechat() && !isLocalhost();
    if (is401 && inWechat) {
      if (shouldOAuthOnIndexAfterBind(reqUrl)) {
        needWechatAuth = true;
        if (pending401JumpTimer) clearTimeout(pending401JumpTimer);
        pending401JumpTimer = setTimeout(() => {
          pending401JumpTimer = null;
          setItem('code', '');
          jumpToWechatAuth();
        }, 400);
        return Promise.reject(new Error('需要授权'));
      }
      return Promise.reject(new Error('会话失效'));
    }
    if (is401) {
      Dialog.alert({ message: '暂无权限' });
      return Promise.reject(new Error('暂无权限'));
    }

    var message = (data && data.msg) || '未知错误';
    // const { error } = data;
    // if (typeof error == 'object') {
    //   message = error.msg || '未知错误';
    // }
    if (status === 404) {
      message = '接口资源不存在';
    }
    if (status === 401) {
      message = '暂无权限';
    }
    if (status === 500) {
      message = '服务器错误';
    }
    // 如果请求为非200否则默认统一处理
    if (status !== 200 && status !== 204) {
      // 微信 code 只能用一次：任何失败都清除 code，避免缓存导致一直用失效 code 重试
      setItem('code', '');
      Dialog.alert({
        message: message,
      });
      return Promise.reject(new Error(message));
    }
    const successUrl = res.config?.url || '';
    if (
      successUrl.includes('/show/') &&
      isWechatAuthRequired() &&
      isWechat() &&
      !isLocalhost()
    ) {
      if (successUrl.includes('code=')) {
        markWechatOAuthDone();
      }
    }
    return data;
  },
  (error) => {
    return Promise.reject(new Error(error));
  }
);

export default axios;
